import { Injectable } from '@angular/core';
import { PrintLabelContentViewModel } from '../../print-label-content-view-model';

@Injectable()
export class BrandInventoryLabelStackContentViewModel extends PrintLabelContentViewModel {}
